import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import html2canvas from 'html2canvas';
import { AppHotelService } from 'src/app/provider/app-hotel.service';
import { CatalogueService } from 'src/app/provider/catalogue.service';
import { ItemService } from 'src/app/provider/item.service';

@Component({
  selector: 'c-qr',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.scss']
})
export class QrCodeComponent implements OnInit {


  constructor(
    private appHotel: AppHotelService,
    public itemService: ItemService,
    public catalog: CatalogueService,
    private cd: ChangeDetectorRef
  ) { }
  @Input() ID: any;

  // For get sub_domain_name
  hotelData = null;

  // For QR Code
  QRloading = true;
  showImage = false;

  type = 'survey-qr';
  qrData: string = null;


  sectionId: number = null;
  itemId: number = null;

  correctionLevel = 'M';


  /* QR CODE VARIABLES AND FUNCTIONS */
  imageData: string[] = [];
  bannerIndex: number = null;

  refresh() {
    this.cd.detectChanges();
  }

  ngOnInit() {
    this.itemService.getData(this.ID, 'menu-item');
    this.catalog.getData(this.ID);
    this.appHotel.getHotelInfo(this.appHotel.popupHotelId || Number(JSON.parse(localStorage.getItem('token_form')).app_hotel_id)).subscribe((resp) => {
      this.hotelData = resp;
      const data = this.itemService.record_change$.getValue();
      this.sectionId = data.menu_section_id;
      this.itemId = data.id;
      this.qrData = 'https://' + this.hotelData.sub_domain_name + '.guestny.com';
    });
    this.QRloading = false;
  }

  select(selectedType: string, URL: string, div: HTMLElement, index: number, image: HTMLElement) {
    this.type = selectedType;
    this.qrData = URL;

    this.convert(div, index, image);
  }

  convert(div: HTMLElement, index: number, image: HTMLElement) {
    const bannerdiv: HTMLElement = document.getElementById('banner-div');

    window.scrollTo(0, 0);
    bannerdiv.style.display = 'flex';
    this.bannerIndex = index;

    this.showImage = true;

    image.style.display = 'block';

    document.body.append(bannerdiv);

    this.refresh();

    const options = {
      dpi: 1500, // Set to 300 DPI
      scrollY: -window.scrollY,
      scrollX: 0,
      allowTaint: true,
      scale: 1.5,
      backgroundColor: null,
      useCORS: true
    };

    setTimeout(() => {
      html2canvas(div, options).then(canvas => {
        this.imageData[index] = canvas.toDataURL('image/png');
        this.convertblob(canvas.toDataURL('image/png'));
      });

      setTimeout(() => {
        this.showImage = false;
        image.style.display = 'none';
        bannerdiv.style.display = 'none';
      }, 100);
    }, 300);

  }

  download(index: number) {
    const link = document.createElement('a');
    link.download = 'html_image.png';
    link.href = this.imageData[index];
    link.target = '_blank';
    link.click();
  }

  convertblob(img: string) {
    const base64ImageData = img;
    const contentType = 'image/png';

    const byteCharacters = atob(base64ImageData.substr(`data:${contentType};base64,`.length));
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    const blobUrl = URL.createObjectURL(blob);

    window.open(blobUrl, '_blank');

    this.refresh();
  }
}
